export interface InstagramModel {
  href: string
  likes: number
  views: number
  original_image: string
  medium_image: string
}

interface InstagramSerializerInput {
  instagram: {
    href: string
    likes: number
    views: number
    original_image: string
    medium_image: string
  }
}

export function InstagramSerializer({
  instagram,
}: InstagramSerializerInput): InstagramModel {
  return {
    href: instagram.href,
    likes: Number(instagram.likes),
    views: Number(instagram.views),
    original_image: instagram.original_image,
    medium_image: instagram.medium_image,
  }
}
